/**
 * Local calendar-day helpers.
 *
 * `toISOString()` is UTC, so using it to derive a 'YYYY-MM-DD' key from a Date
 * built with `new Date(y, m, d)` (which is LOCAL midnight) silently shifts the
 * day for most of the world: in IST, local midnight on the 14th is 18:30 UTC on
 * the 13th, so the key comes back a day early and records land on the wrong
 * calendar cell. Anything that turns a Date into a day string for display,
 * lookup, or an <input type="date"> must go through here.
 */

/** Local 'YYYY-MM-DD' for a Date — never toISOString, which is UTC. */
export const localDateStr = (d = new Date()) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

/** Today as a local 'YYYY-MM-DD' — for `max` on a date input, "is today", etc. */
export const todayStr = () => localDateStr(new Date());

/** Local 'YYYY-MM-DD' n days from now (negative for the past). */
export const daysFromTodayStr = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return localDateStr(d);
};
